import Login from "../features/Auth/Component/Login";
import Navbar from "../features/Navbar/Navbar";

export default function LoginPage() {
  return (
    <div>
      <Navbar></Navbar>
      <Login />
    </div>
  );
}
